import { Constructor } from "core-library/types/constructor";

export interface ILockable {
    isLocked: boolean;
    lock(): void;
    unlock(): void;
}

export const LockMixin = <TBaseClass extends Constructor<object>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<ILockable> => {
    return class LockableExtension extends BaseClass implements ILockable {
        private _isLocked: boolean = false;

        public get isLocked(): boolean {
            return this._isLocked;
        }

        public lock(): void {
            this._isLocked = true;
        }

        public unlock(): void {
            this._isLocked = false;
        }
    };
};
